import styled from 'styled-components';
import {baseColors} from '../../../../../../../../themes/definitions/mrgreen/base-colors';
import {TableContainerDefaultBox} from './table-container.default.box';

export const TableContainerMrGreenBox = styled(TableContainerDefaultBox)`
    & tr {            
        &:nth-of-type(odd){
          background: transparent;
        }
    }

    & td {
        border-bottom: 1px solid ${baseColors.white};
        border-top: none
    }
`;